/* eslint-disable react/prop-types */
import React, { useState, useEffect, MouseEvent } from "react";
import Grid from "@mui/material/Grid";
// import Modal from "@mui/material/Modal";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import ToggleButton from '@mui/material/ToggleButton';
import { Icon } from "@mui/material";

import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";

import moment from "moment";


// Material Dashboard 2 React Components
function FilterDialog(props) {
    const [notiDetails, setShowDetails] = useState({ show: false });
    const [from, setFrom] = useState(new Date());
    const [to, setTo] = useState(new Date());
    const [status, setStatus] = useState(props.details.status);



    const closeSB = () => setShowDetails({ ...notiDetails, show: false });

    const handleChange = (event) => {
        console.log(event);
        switch (event.target.name) {

        }
    };

    const changeStatus = (variable, value) => {
        if (value) {
            setStatus([...status, variable]);
        }
        else {
            let arr = [...status];
            const indexOfElementToRemove = arr.indexOf(variable);
            if (indexOfElementToRemove !== -1) {
                arr.splice(indexOfElementToRemove, 1);
            }
            setStatus(arr);
        }
    }

    useEffect(() => {
        console.log("modal useEffect");
        if (props.details) {
            setFrom(props.details.from);
            setTo(props.details.to);
            setStatus(props.details.status);
        }
    }, []);



    function isNumeric(value) {
        return /^\d+$/.test(value);
    }


    const renderSB = (
        <MDSnackbar
            color={notiDetails.color}
            icon={notiDetails.icon}
            title={notiDetails.title}
            content={notiDetails.message}
            dateTime=""
            open={notiDetails.show}
            onClose={closeSB}
            close={closeSB}
            bgWhite
        />
    );




    return (
        <Dialog
            id="modal-display"
            open={props.isopen}
            aria-labelledby="form-dialog-title"
            aria-describedby="modal-modal-description"
            maxWidth="90%"
            onClose={props.handleclose}
        >
            <DialogContent style={{ width: 700, height: 'auto' }}>
                <FormGroup>
                    <MDBox component="form" noValidate width="100%">
                        <MDTypography
                            variant="h5"
                            fontWeight="bold"
                            color="dark"
                        >
                            {"Filters"}
                        </MDTypography>

                        <Grid
                            container xs={12}
                            direction='row'
                            width={"100%"}
                            className="form-wrapper"
                            style={{ display: 'flex', alignItems: 'center', justifyContent: "space-around", margin: 10 }}
                        >
                            <Grid item xs={5} className="form-content">
                                <MDInput
                                    sx={{ width: "100%" }}
                                    type="date"
                                    label="From Time"
                                    value={moment(from).format("YYYY-MM-DD")}
                                    onChange={(event) => {
                                        setFrom(event.target.valueAsDate);
                                    }}
                                />
                            </Grid>
                            <Grid item xs={5} className="form-content">
                                <MDInput
                                    sx={{ width: "100%" }}
                                    type="date"
                                    label="To Time"
                                    value={moment(to).format("YYYY-MM-DD")}
                                    onChange={(event) => {
                                        setTo(event.target.valueAsDate);
                                    }}
                                />
                            </Grid>
                        </Grid>


                        {/** Third Row **/}
                        <Grid
                            container xs={12}
                            direction='row'
                            width={"100%"}
                            className="form-wrapper"
                            style={{ display: 'flex', alignItems: 'center', justifyContent: "space-around", margin: 10 }}
                        >
                            {/* <Grid item xs={5} className="form-content">
                                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Department</InputLabel>
                  <Select
                    sx={{ height: 40 }}
                    labelId="demo-simple-select-label"
                    id="department"
                    // value={selDept}
                    label="Department"
                    // onChange={handleChange}
                    name="department"
                    // error={(selDept === "") || (!selDept)}
                  >
                    {depts.map((ele) => {
                      return <MenuItem value={ele._id}>{ele.name}</MenuItem>
                    })}
                  </Select>
                </FormControl>
                            </Grid> */}
                            <FormGroup row>
                                <FormControlLabel control={<Checkbox defaultChecked={status.includes(0)} onChange={(event) => {
                                    // Handle label checkbox change
                                    console.log('Pending Checkbox Change:', event.target.checked);
                                    changeStatus(0, event.target.checked);
                                }} />} label="Pending" />
                                <FormControlLabel control={<Checkbox defaultChecked={status.includes(1)} onChange={(event) => {
                                    // Handle label checkbox change
                                    console.log('In Transit Checkbox Change:', event.target.checked);
                                    changeStatus(1, event.target.checked);
                                }} />} label="In Transit" />
                                <FormControlLabel control={<Checkbox defaultChecked={status.includes(2)} onChange={(event) => {
                                    // Handle label checkbox change
                                    console.log('On Hold Checkbox Change:', event.target.checked);
                                    changeStatus(2, event.target.checked);
                                }} />} label="On Hold" />
                                <FormControlLabel control={<Checkbox defaultChecked={status.includes(3)} onChange={(event) => {
                                    // Handle label checkbox change
                                    console.log('Deliverd Checkbox Change:', event.target.checked);
                                    changeStatus(3, event.target.checked);
                                }} />} label="Delivered" />
                                <FormControlLabel control={<Checkbox defaultChecked={status.includes(4)} onChange={(event) => {
                                    // Handle label checkbox change
                                    console.log('Issue Checkbox Change:', event.target.checked);
                                    changeStatus(4, event.target.checked);
                                }} />} label="Issue" />
                                <FormControlLabel control={<Checkbox defaultChecked={status.includes(5)} onChange={(event) => {
                                    // Handle label checkbox change
                                    console.log('Picked Up Checkbox Change:', event.target.checked);
                                    changeStatus(5, event.target.checked);
                                }} />} label="Picked Up" />
                            </FormGroup>
                        </Grid>

                        <Grid
                            container xs={12}
                            direction='row'
                            width={"100%"}
                            className="form-wrapper"
                            style={{ display: 'flex', alignItems: 'center', justifyContent: "flex-end", marginTop: 20 }}
                        >
                            <MDButton variant="gradient" color="success" style={{ margin: 5 }}
                                onClick={() => {
                                    console.log(status);
                                    props.apply({from: from, to: to, status: status});
                                }}>
                                {/* <Icon sx={{ fontWeight: "bold" }}>add</Icon> */}
                                &nbsp;Apply
                            </MDButton>
                        </Grid>
                        {renderSB}
                    </MDBox>
                </FormGroup>
            </DialogContent>
        </Dialog >
    )
};

export default FilterDialog;